import React from 'react'
import './HeroSlider.css'
import hero_image from '../Assets/banner-side-1-1111x1148px.png'
import { useNavigate } from 'react-router-dom'

const HeroSlider = () => {

    const navigate = useNavigate();

    return (
        <div className="hero-wrapper">
            <div className='hero'>

                <div className="hero-left">
                    <div className="hero-text-group">
                        {/* <p className="hero-eyebrow">New Collection</p> */}
                        <h1 className="hero-heading">
                            Welcome to<br />
                            <span className="hero-heading-brand">JENITAS</span>
                        </h1>
                        <div className="hero-divider" />
                        <p className="hero-tagline">Your everyday style, elevated</p>
                    </div>
                    <button className="hero-btn" onClick={() => navigate('/shop-products')}>
                        Shop Now
                        <span className="hero-btn-arrow">→</span>
                    </button>
                </div>
                
                <div className="hero-right">
                    <div className="hero-img-wrap">
                        <img src={hero_image} alt="Jenita's Fashion" />
                    </div>
                </div>
                
            </div>
        </div>
    )
}

export default HeroSlider